import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/logo/OFFICIAL_BINKLEY_LOGO.webp";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const current = window.scrollY;
      if (current > lastScroll && current > 100) setIsHidden(true);
      else setIsHidden(false);
      setLastScroll(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScroll]);

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu = () => setIsMenuOpen(false);
  const openDropdown = () => setDropdownOpen(true);
  const closeDropdown = () => setDropdownOpen(false);
  const toggleDropdown = () => setDropdownOpen((v) => !v);

  const closeAll = () => {
    closeMenu();
    closeDropdown();
  };

  return (
    <nav className={`navbar ${isHidden ? "hidden" : ""}`} aria-label="Main navigation">
      {/* Hamburger button */}
      <button
        className={`hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}
        aria-controls="primary-navigation"
        aria-label="Toggle navigation menu"
      >
        <span />
        <span />
        <span />
      </button>

      {/* Nav links */}
      
      
      <ul id="primary-navigation" className={`nav-links ${isMenuOpen ? "active" : ""}`}>
        {/* Mobile-only Home link */}
        <li className="mobile-home">
          <NavLink to="/" onClick={closeAll}>Home</NavLink>
        </li>

        {/* Dropdown: About */}
        <li
          className="dropdown"
          onMouseEnter={openDropdown}
          onMouseLeave={closeDropdown}
        >
          <NavLink to="/about" onClick={closeMenu}>About Us</NavLink>
          <button
            className="dropdown-toggle"
            aria-expanded={dropdownOpen}
            aria-controls="about-submenu"
            aria-label="Toggle About submenu"
            onClick={toggleDropdown}
          >
            ▾
          </button>
          {dropdownOpen && (
            <ul id="about-submenu" className="dropdown-menu">
              <li><NavLink to="/about" onClick={closeAll}>About Us</NavLink></li>
              <li><NavLink to="/about/mission" onClick={closeAll}>Mission</NavLink></li>
              <li><NavLink to="/about/curriculum" onClick={closeAll}>Curriculum & Play Spaces</NavLink></li>
              <li><NavLink to="/parent-involvement" onClick={closeMenu}>Parent Involvement</NavLink></li>
              <li><NavLink to="/about/tuition" onClick={closeAll}>Tuition & Scholarships</NavLink></li>
            </ul>
          )}
        </li>


        {/* Other links */}
        <li><NavLink to="/staff" onClick={closeMenu}>Staff</NavLink></li>
        <li><NavLink to="/classes" onClick={closeMenu}>Classes</NavLink></li>
        

                {/* Logo (desktop & center) */}
        <li className="logo">
          <NavLink to="/" aria-label="Homepage" onClick={closeMenu}>
            <img src={logo} alt="Binkley Preschool Logo" className="logo-image" />
          </NavLink>
        </li>


        <li><NavLink to="/current-families" onClick={closeMenu}>Current Families</NavLink></li>
        <li><NavLink to="/fundraising" onClick={closeMenu}>Fundraising</NavLink></li>
        <li><NavLink to="/application" onClick={closeMenu}>Application</NavLink></li>
        <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>

        {/* Mobile-only Close button */}
        <li className="mobile-close">
          <button onClick={closeAll} aria-label="Close menu">✕</button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
